module.exports = __webpack_public_path__ + "img/万盛-重庆青山湖国家湿地公园@2x.d2ecc303.png";